import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { register } from 'swiper/element/bundle';

import { AppComponent } from './app/app.component';
import { APP_CONFIG } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
} else {
  import('./mocks/browser');
}

// Register Swiper custom elements
register();

bootstrapApplication(AppComponent, APP_CONFIG)
  .catch((err) => console.error(err));
